<template>
  <div>
    <h5 class="header-stripe">
      <span>{{$t('INDENT_CONTAINER_PICKED')}}</span>
      <div class="action">
        <Button type="secondary" size="mini" @click="$emit('cancelAction')">{{$t('INDENT_CANCEL')}}</Button>
        <Button type="primary" size="mini" @click="containerPicked">{{$t('INDENT_SUBMIT')}}</Button>
      </div>
    </h5>
    <div class="py-15">
      <Form :inline="true" class="form-default form-triple">
        <div class="form-item-group">
          <FormItem :label="$t('INDENT_CONTAINER_NUMBER')" required>
            <Input placeholder="900132CTZOXXXX" v-model.trim.lazy="containerNumber" />
          </FormItem>
          <FormItem :label="$t('INDENT_LINE_SEAL_NUMBER')" required>
            <Input placeholder="CTZP12345XXXX" v-model.trim.lazy="lineSealNumber"/>
          </FormItem>
        </div>
        <div class="form-item-group">
           <FormItem label="Empty Container Pickup Port">
            <Input placeholder="Empty Container Pickup Port" :value="containerPickupLocation" :disabled="true"/>
          </FormItem>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import {
  required,
  minLength,
  alphaNum,
} from 'vuelidate/lib/validators';

export default {
  props: ['containerPickupLocation'],
  data() {
    return {
      lineSealNumber: '',
      containerNumber: '',
    };
  },
  validations: {
    lineSealNumber: { required, alphaNum, minLength: minLength(1) },
    containerNumber: { required, alphaNum, minLength: minLength(1) },
  },
  methods: {
    async containerPicked() {
      this.$v.containerNumber.$touch();
      this.$v.lineSealNumber.$touch();
      if(this.$v.containerNumber.$dirty && this.$v.containerNumber.$error) {
        this.$errorMessage({ message: this.$getErr('INVALID_CONTAINER_NUMBER') });
        return;
      } else if(this.$v.lineSealNumber.$dirty && this.$v.lineSealNumber.$error) {
        this.$errorMessage({ message: this.$getErr('INVALID_LINE_SEAL_NUMBER') });
        return;
      } else {
        const data = {};
        data.container_number = this.containerNumber;
        data.line_seal_number = this.lineSealNumber;
        this.$emit('containerPickup', data);
      }
    },
  },
};
</script>
